var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34ZM20 31.375C26.2822 31.375 31.375 26.2822 31.375 20C31.375 13.7178 26.2822 8.625 20 8.625C13.7178 8.625 8.625 13.7178 8.625 20C8.625 26.2822 13.7178 31.375 20 31.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9272 13.9231C25.3617 13.621 25.8711 14.171 25.5913 14.6401L22.059 20.5616C21.8931 20.8397 21.5319 20.8814 21.3153 20.6476L19.3631 18.5398C19.1465 18.306 19.1851 17.9159 19.4427 17.7368L24.9272 13.9231Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0723 25.9988C14.6379 26.3009 14.1284 25.7508 14.4082 25.2817L17.9405 19.3603C18.1064 19.0822 18.4676 19.0405 18.6842 19.2743L20.6364 21.3821C20.853 21.6159 20.8144 22.006 20.5568 22.185L15.0723 25.9988Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconShortcut);
export default __webpack_public_path__ + "static/media/NavIconShortcut.d83b7f75c2484a86695d358cd89288d3.svg";
export { ForwardRef as ReactComponent };